import { IDealerAgreement, IUpdateDealerAgreementParams } from '@common.abstractions';
import { BACKEND_URL } from '@frontend/environment';
import axios from 'axios';

export async function UpdateDealerContract(pandadocId: string, params: IUpdateDealerAgreementParams): Promise<IDealerAgreement> {
    const response = await axios.patch(`${BACKEND_URL}/contract/${pandadocId}`, params);
    return response.data;
}